import { render, staticRenderFns } from "./ListAssetComponent.vue?vue&type=template&id=12e5012c&"
import script from "./ListAssetComponent.vue?vue&type=script&lang=js&"
export * from "./ListAssetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports